module.exports = ["IN", "US", "AE", "SA", "QA", "OM", "KW", "EG", "BH"];
